// extracted by mini-css-extract-plugin
module.exports = {"container":"OptionRoundedButton_container__1RKwC","arrow":"OptionRoundedButton_arrow__1rdkl","label":"OptionRoundedButton_label__vY5Sb"};